import { render, staticRenderFns } from "./TablePopup.vue?vue&type=template&id=38fbe45c&scoped=true&"
import script from "./TablePopup.vue?vue&type=script&lang=js&"
export * from "./TablePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fbe45c",
  null
  
)

export default component.exports